export default {
  ESI_WREATH: 1,
  ESI_ICE: 2,
  ESI_CANDY: 3,
  ESI_CANDLE: 4,
  ESI_SOCK: 5,
  ESI_COOKIE: 6,
  ESI_BOMB: 7,
  ESI_SNOW: 8,
  ESI_SCATTER: 10,
}
